import React from 'react';
import { Link } from 'react-router-dom';
import './ServiceCard.css';

const services = [
  {
    icon: '🌐',
    title: 'Website Design & Development',
    description: 'Custom Web Development, WordPress, Squarespace',
    path: '/website-design-development',
  },
  {
    icon: '📈',
    title: 'Digital Marketing and SEO',
    description: 'SEO, SMO, PPC, Email Marketing, Content Writing, Reputation Management',
    path: '/digital-marketing-seo',
  },
  {
    icon: '🛡️',
    title: 'Software Quality Assurance',
    description: 'AWS, Website Transfer, Shared hosting, VPS hosting, Dedicated Server, Domain Setup',
    path: '/software-quality-engineering',
  },
  {
    icon: '📱',
    title: 'Mobile App Development',
    description: 'SSL, Malware Removal, Website Backup, Optimization',
    path: '/mobile-app-development',
  },
  {
    icon: '⚙️',
    title: 'Advanced Test Automation',
    description: 'Mockup & Logo Design, Flash Animations, Motion Graphics',
    path: '/advanced-test-automation',
  },
  {
    icon: '🤖',
    title: 'AI Related Services',
    description: 'AI strategy, LLM integration, workflow automation, predictive analytics',
    path: '/ai-related-services',
  },
  {
    icon: '🔗',
    title: 'IOT Development',
    description: 'iOS Applications, Android Applications, Hybrid Applications',
    path: '/website-design-development',
  },
];

const ServicesSection = () => {
  return (
    <section className="snow-services" id="services">
      <div className="snow-services-inner">
        <div className="snow-section-header">
          <span className="snow-section-label">❆ What We Offer</span>
          <h2 className="snow-section-title">
            We Provide Fastest & Unique Business Growing Services
          </h2>
          <p className="snow-section-subtitle">
            Cutting-edge solutions crafted with precision and expertise
          </p>
        </div>

        <div className="snow-services-grid">
          {services.map((service, index) => (
            <Link
              key={index}
              className="snow-service-card glass-card"
              style={{ animationDelay: `${index * 0.1}s` }}
              to={service.path}
            >
              <div className="snow-service-icon-wrap">
                <span className="snow-service-icon">{service.icon}</span>
              </div>
              <h3 className="snow-service-title">{service.title}</h3>
              <p className="snow-service-desc">{service.description}</p>
              <div className="snow-service-arrow">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M5 10H15M15 10L10 5M15 10L10 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <div className="snow-service-frost-line"></div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
